// src/components/SettingsModal.jsx
import React, { useState, useEffect, useRef } from 'react';
import Modal from './Modal';
import { toast } from './Toast';

export default function SettingsModal({
  open,
  onClose,
  userData,
  onSave,
  activeHouseId
}) {
  const [form, setForm] = useState({ ...userData });
  const sendingRef = useRef(false);

  useEffect(() => {
    if (open) {
      setForm({ ...userData });
      sendingRef.current = false;
    }
  }, [userData, open]);

  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  // ─────────────────────────────
  // SAVE SETTINGS
  // ─────────────────────────────
  const handleSave = async () => {
    try {
      await onSave(form);
      toast('✅ Paramètres sauvegardés');
      onClose();
    } catch (err) {
      console.error(err);
      toast('⚠️ Erreur sauvegarde');
    }
  };

  // ─────────────────────────────
  // TEST EMAIL via /api
  // ─────────────────────────────
  const handleTestEmail = async () => {
    if (sendingRef.current) return;

    if (!form.email) {
      toast("⚠️ Ajoutez votre email d'abord");
      return;
    }

    if (!activeHouseId) {
      toast('⚠️ Sélectionnez une maison d’abord');
      return;
    }

    sendingRef.current = true;

    try {
      await onSave(form);

      toast('📧 Envoi en cours…');

      const res = await fetch('/api/send-email', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          email: form.email,
          name: form.name || 'Utilisateur',
          houseName: 'Maison',
          items: [
            {
              name: 'Test produit',
              expiry: '2026-05-10'
            },
            {
              name: 'Produit demo',
              expiry: '2026-05-08'
            }
          ]
        })
      });

      const data = await res.json();

      if (!res.ok) {
        throw new Error(data?.error || 'Erreur API');
      }

      toast('📧 Email envoyé avec succès');

    } catch (err) {
      console.error(err);
      toast('⚠️ ' + (err.message || 'Erreur envoi email'));
    } finally {
      sendingRef.current = false;
    }
  };

  return (
    <Modal open={open} onClose={onClose} title="⚙️ Paramètres">

      <div className="sinfo">
        📧 Les emails sont envoyés via ton backend <strong>/api/send-email</strong>
      </div>

      <div className="fgroup">
        <label className="flabel">Votre email</label>
        <input
          className="finput"
          type="email"
          value={form.email || ''}
          onChange={e => set('email', e.target.value)}
        />
      </div>

      <div className="fgroup">
        <label className="flabel">Votre prénom</label>
        <input
          className="finput"
          value={form.name || ''}
          onChange={e => set('name', e.target.value)}
        />
      </div>

      <div className="fgroup">
        <label className="flabel">Délai d'alerte</label>
        <select
          className="fselect"
          value={form.alertDays || 7}
          onChange={e => set('alertDays', Number(e.target.value))}
        >
          <option value={3}>3 jours</option>
          <option value={5}>5 jours</option>
          <option value={7}>7 jours</option>
          <option value={14}>14 jours</option>
        </select>
      </div>

      <div className="sinfo red">
        💡 Backend utilisé : <code>/api/send-email</code>
      </div>

      <button className="bsubmit" onClick={handleSave}>
        💾 Sauvegarder
      </button>

      <button className="bwarn" onClick={handleTestEmail} disabled={sendingRef.current}>
        📧 Tester l’envoi email
      </button>

      <button className="bcancel" onClick={onClose}>
        Fermer
      </button>

    </Modal>
  );
}